import React from 'react';
import Dentalnavbar from '../webcomp/Dentalnavbar';
import Footer from '../webcomp/Footer';
import Loginform from '../webcomp/Loginform';

const Loginpage = () => {
    return(
        <>
            <Dentalnavbar/>
            <Loginform/>
        </>
    )
}
export default Loginpage;